import * as yup from 'yup'

const schema = yup.object().shape({
  recommendations: yup.string(),
  legalBase: yup.string(),
  lia: yup.string(),
})

export default schema
